import api from '@/helpers/api'
import qs from 'qs'

export default {
  requestLastId (id_cabang, nama_lengkap, jk) {
    var pasien = {
      id_cabang: id_cabang,
      nama_lengkap: nama_lengkap,
      jk: jk,
    }

    return api.post('/id_pasien', qs.stringify(pasien))
  },
  getPasien (data) {
    return api.get('/pasien?' + qs.stringify(data))
  },
  getPasienDetail (id) {
    return api.get('/pasien/' + id)
  },
  addPasien (pasien) {
    return api.post('/pasien', qs.stringify(pasien))
  },
  updatePasien (id, pasien) {
    return api.patch('/pasien/' + id, qs.stringify(pasien))
  },
  deletePasien (id) {
    var pasien = []
    return api.delete('/pasien/' + id, qs.stringify(pasien))
  },
  rekamMedisForm () {
    return api.get('/rekam_medis_form')
  },
  addRekamMedis (rekamMedis) {
    return api.post('/rekam_medis', rekamMedis)
  },
  getBaseUrl () {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
    return api.defaults.baseURL
  }
}
